import React from 'react';
import { FacetItemProps } from '../../../types';

export const FacetItem: React.FC<FacetItemProps> = ({
  label,
  count,
  isActive,
  onClick,
  onKeyDown,
}) => (
  <button
    type="button"
    onClick={onClick}
    onKeyDown={onKeyDown}
    className={
      'ee-search-facetItem' + (isActive ? ' ee-search-facetItem--active' : '')
    }
    aria-pressed={isActive}
    aria-label={`Filter by ${label}, ${count} results`}
  >
    <span className="ee-search-facetLabel">{label}</span>
    <span className="ee-search-facetCount">({count})</span>
  </button>
);
